export const Colors = {
    black: '#2a2624',
    red: '#fe5139',
    white: '#fffbdf',
    grey: '#47677b',
    blue: '#3A7CA5',
    lightGrey: '#f6f6f6',
    trueWhite: '#ffffff',
    green: '#1DB954',
    lightGold: '#e8ca84',
    gold: '#d2973b',
    sea: '#2f576e',
    navy: '#0d1e2f',
    newBlack: '#051016',
    pink: '#f99cb2'
}